import { getUserProfileCall } from '@/core/state';
import { Claims } from '../constants';

/**
 * Custom hook to check if a specific claim is present in the user's profile.
 *
 * @param {Claims} claim - The claim to check for in the user's profile.
 * @returns {boolean | undefined} - Returns `true` if the claim is present, `false` if not,
 *                                  or `undefined` if the user profile is not yet loaded.
 */
export const useClaims = (claim: Claims) => {
  const { response: responseGetUserProfile } = getUserProfileCall.hook();
  return responseGetUserProfile?.claims?.includes(claim);
};
